module.exports = __webpack_public_path__ + "media/icons/ic_noburo_heart-b5dd1bcc.svg";